import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Live EuroLeague/EuroCup scores by game id, polled every 30s.
export function useEuroLive() {
  const [live, setLive] = useState({});
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/euro/live").then((r) => alive && setLive(Object.fromEntries(r.data.map((g) => [g.id, g])))).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  return live;
}

export const periodLabel = (q) => {
  const n = Number(q);
  if (!q) return "";
  if (!Number.isFinite(n)) return q;
  return n <= 4 ? `Q${n}` : `OT${n - 4 > 1 ? n - 4 : ""}`;
};
